
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLocationN as ObiLocationNElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-location-n.js';
 
 
 

 
 export const ObiLocationN = createComponent({
   react: React,
   tagName: 'obi-location-n',
   elementClass: ObiLocationNElement,
   events: {
     
   }
  });
 
 